module.exports = __webpack_public_path__ + "60258ccd34f5dd2b4dda517533ed3524.MP3";